
export interface ShardBucketRange {
    bucketRangeStart: number;
    shardNumber: number;
}
